/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_Status_UnchangedInputs */

const id_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak berubah`)
};

const ms_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak berubah`)
};

const da_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uændret`)
};

const de_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unverändert`)
};

const en_us2_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unchanged`)
};

const es_es2_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin cambios`)
};

const es_mx2_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin cambios`)
};

const fil_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang pagbabago`)
};

const fr_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inchangé`)
};

const it_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invariato`)
};

const hu_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Változatlan`)
};

const nl_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ongewijzigd`)
};

const no_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uendret`)
};

const pl_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez zmian`)
};

const pt_br2_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem alterações`)
};

const pt_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem alterações`)
};

const ro_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neschimbat`)
};

const fi_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muuttumaton`)
};

const sv_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oförändrad`)
};

const vi_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thay đổi`)
};

const tr_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değişmedi`)
};

const cs_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beze změny`)
};

const bg_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Без промяна`)
};

const ru_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Без изменений`)
};

const uk_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Без змін`)
};

const ar_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دون تغيير`)
};

const hi_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपरिवर्तित`)
};

const th_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่เปลี่ยนแปลง`)
};

const ja_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更なし`)
};

const zh_cn2_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未更改`)
};

const zh_hant1_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未變更`)
};

const ko_builds_comparison_status_unchanged = /** @type {(inputs: Builds_Comparison_Status_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변경 없음`)
};

/**
* | output |
* | --- |
* | "Unchanged" |
*
* @param {Builds_Comparison_Status_UnchangedInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_status_unchanged = /** @type {((inputs?: Builds_Comparison_Status_UnchangedInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_Status_UnchangedInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_status_unchanged(inputs)
	if (locale === "ms") return ms_builds_comparison_status_unchanged(inputs)
	if (locale === "da") return da_builds_comparison_status_unchanged(inputs)
	if (locale === "de") return de_builds_comparison_status_unchanged(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_status_unchanged(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_status_unchanged(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_status_unchanged(inputs)
	if (locale === "fil") return fil_builds_comparison_status_unchanged(inputs)
	if (locale === "fr") return fr_builds_comparison_status_unchanged(inputs)
	if (locale === "it") return it_builds_comparison_status_unchanged(inputs)
	if (locale === "hu") return hu_builds_comparison_status_unchanged(inputs)
	if (locale === "nl") return nl_builds_comparison_status_unchanged(inputs)
	if (locale === "no") return no_builds_comparison_status_unchanged(inputs)
	if (locale === "pl") return pl_builds_comparison_status_unchanged(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_status_unchanged(inputs)
	if (locale === "pt") return pt_builds_comparison_status_unchanged(inputs)
	if (locale === "ro") return ro_builds_comparison_status_unchanged(inputs)
	if (locale === "fi") return fi_builds_comparison_status_unchanged(inputs)
	if (locale === "sv") return sv_builds_comparison_status_unchanged(inputs)
	if (locale === "vi") return vi_builds_comparison_status_unchanged(inputs)
	if (locale === "tr") return tr_builds_comparison_status_unchanged(inputs)
	if (locale === "cs") return cs_builds_comparison_status_unchanged(inputs)
	if (locale === "bg") return bg_builds_comparison_status_unchanged(inputs)
	if (locale === "ru") return ru_builds_comparison_status_unchanged(inputs)
	if (locale === "uk") return uk_builds_comparison_status_unchanged(inputs)
	if (locale === "ar") return ar_builds_comparison_status_unchanged(inputs)
	if (locale === "hi") return hi_builds_comparison_status_unchanged(inputs)
	if (locale === "th") return th_builds_comparison_status_unchanged(inputs)
	if (locale === "ja") return ja_builds_comparison_status_unchanged(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_status_unchanged(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_status_unchanged(inputs)
	return ko_builds_comparison_status_unchanged(inputs)
});
export { builds_comparison_status_unchanged as "builds.comparison.status.unchanged" }